import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_66y0zxfe0m: FaireBrandEntity = {
  token: "b_66y0zxfe0m",
  type: "brand",
  name: "Glyder",
  avatarUrl:
    "https://cdn.faire.com/fastly/5822db0cf13932fedbd8cc20e210e2e881fceb3304018bb3c374941f9bb755fd.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a2661191dff700f9ab9dac7539306770ddafab618c4e50001d2677daa6d802b7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5822db0cf13932fedbd8cc20e210e2e881fceb3304018bb3c374941f9bb755fd.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a2661191dff700f9ab9dac7539306770ddafab618c4e50001d2677daa6d802b7.jpeg",
  location: "Santa Ana, CA, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 7,
  isTopShop: true,
  isInsider: true,
  description:
    "LIMITLESS MOVEMENT.\n\nFrom day one, Glyder’s mission has been to cultivate a community of people who live life without limits. Those who see a boundary and break through it. Since we are all unique and no adventure is the same, we make it our focus to design multifunctional pieces that will perform with any activity. We create pieces that can take you from studio, to street, to the highest peak, all in one outfit. Designed for those who never say the words “I can’t,” Glyder provides gear and inspiration to explore new experiences and forge your own path.\n\nThere’s no dream too big, and the possibilities are limitless – Glyder.\n ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:38.341Z",
    importedBy: "entity-db-cli",
  },
};
